import { Type, Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  TextField,
  BooleanField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Схема территорий продаж.
 *
 * Описывает справочник территорий/зон, привязанных к партнёрам.
 */
export const SalesAreaSchema = Type.Object({
  ...SystemFields,

  name: StringField({
    title: 'Название территории',
    minLength: 1,
    maxLength: 255,
    description: 'Человекочитаемое название территории продаж.',
  }),

  description: TextField({
    title: 'Описание территории',
    nullable: true,
    description: 'Дополнительное описание территории продаж.',
  }),

  is_active: BooleanField({
    title: 'Территория активна',
    default: true,
    description: 'Флаг, определяющий доступность территории для назначения.',
  }),
});

export type SalesArea = Static<typeof SalesAreaSchema>;

export default defineSchema({
  moduleName,
  tableName: 'sales_areas',
  schema: SalesAreaSchema,
  additionalIndexes: [{ columns: ['name'], unique: true }, 'is_active'],
  dependencies: [],
});
